import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS, ApiEndpoints, ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GroupBaselineService {
  constructor(
    private apiCilent: ApiCilent,
    @Inject(API_ENDPOINTS) private readonly endpoints: ApiEndpoints,
  ) {}
  endpoint = this.endpoints.group_baseline;

  getBaselineGroup(): Observable<ApiResponse<any>> {
    return this.apiCilent.get(this.endpoint.get.group);
  }

  getBaselineGraph(query: any): Observable<ApiResponse<any>> {
    return this.apiCilent.get({
      ...this.endpoint.get.graph,
      query,
    });
  }

  getBaselineLog(): Observable<any> {
    return this.apiCilent.get(this.endpoint.get.log!);
  }

  createBaselineGroup(body: any): Observable<ApiResponse<any>> {
    return this.apiCilent.post({ ...this.endpoint.create.group, body });
  }

  updateBaselineGroup(body: any): Observable<ApiResponse<any>> {
    return this.apiCilent.put({ ...this.endpoint.update.group, body });
  }

  deleteBaselineGroup(id: any): Observable<ApiResponse<any>> {
    return this.apiCilent.delete({
      ...this.endpoint.delete.group,
      query: { id },
    });
  }
}
